













































































































































import Component from "vue-class-component";
import InsertionRepository from "@/repositories/insertion/InsertionRepository";
import SearchButton from "front-component/components/SearchButton.vue";
import ViewList from "@/views/List.vue";
import InsertionList from "@/components/insertion/list/List.vue";
import Detail from "@/components/insertion/Detail.vue";
import DocumentsList from "@/components/insertion/DocumentsList.vue";
import KeywordSearch from "@/components/forms/search/KeywordSearch.vue";
import MediaSearch from "@/components/forms/search/insertion/MediaSearch.vue";
import SelectSearch from "@/components/forms/search/SelectSearch.vue";
import MultipleSelectSearch from "@/components/forms/search/MultipleSelectSearch.vue";
import DatePickerSearch from "@/components/forms/search/DatePickerSearch.vue";
import * as Constants from "@/Constants";
import _ from "lodash";
import { Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import Http from "front-component/Http";
import EventBus from "front-component/EventBus";
import SelectOwner from "@/components/owner/SelectOwner.vue";
import {APPLICATION_JO, ptfFeatures} from "@/Constants";
import {Type} from "@/modules/request/Type";

const components = {
    SearchButton,
    InsertionList,
    Detail,
    DocumentsList,
    KeywordSearch,
    MediaSearch,
    SelectSearch,
    DatePickerSearch,
    MultipleSelectSearch,
    SelectOwner,
};

export interface Option {
    key: string;
    label: string;
    deep?: number;
    hidden?: boolean;
}

@Component({
    methods: {
        APPLICATION_JO() {
            return APPLICATION_JO;
        }
    },
    components })
export default class List extends ViewList {
    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string;
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;
    @Getter("hasApplication") public hasApplication!: (application: string) => boolean;
    @Getter("getTypes") public types!: Type[];

    protected filters: object = { status: "" };
    protected orders: object = { broadcastStartDate: "DESC" };

    private modalDetailVisible: boolean = false;
    private modalDocumentVisible: boolean = false;
    private currentInsertionUuid: string|null = null;
    private currentYear: number = new Date().getFullYear();

    private optionsMedia = Constants.optionsMedia;
    private optionsMarketYear: any[] = [];
    private beginMarketYear: number = 2012;
    private optionsStatus = Constants.optionsStatus;
    private optionsProofs = Constants.optionsProofs;
    private optionsSupportInvoices = Constants.optionsSupportInvoices;
    private optionsSupplier: any[] = [];
    private optionsSupport: any[] = [];
    private optionsRequestType: Option[] = [];
    private allSupport: any[] = [];
    private loadingSupplier: boolean = false;
    private loadingSupport: boolean = false;
    private exportDisabled: boolean = false;
    private hiddenComponent: string[] = [];

    private datePickerAvailable: boolean = false;
    private unwatchCurrentOwnerUuidInit: (() => void) | undefined;

    public mounted(): void {
        this.setOptionsRequestType();
        for (let i = this.beginMarketYear; i <= this.currentYear + 1; i++) {
            this.optionsMarketYear.push({ key: i, label: i });
        }
        this.exportDisabled = true;
        if (this.hasFeature("HIDE_PERIOD_COLUMNS")) {
            this.hiddenComponent.push("invoicingPeriod");
            this.hiddenComponent.push("paymentPeriod");
        }

        if (this.currentOwnerUuid) {
            _.set(this.filters, "marketYear", [this.currentYear]);
            _.set(this.filters, "ownerUuid", this.currentOwnerUuid);
        } else {
            this.unwatchCurrentOwnerUuidInit = this.$watch("currentOwnerUuid", (newCurrentOwnerUuid) => {
            if (newCurrentOwnerUuid) {
                _.set(this.filters, "marketYear", [this.currentYear]);
                _.set(this.filters, "ownerUuid", this.currentOwnerUuid);
                if (this.unwatchCurrentOwnerUuidInit) {
                    this.unwatchCurrentOwnerUuidInit();
                }
            }
        });
      }
    }

    @Watch("currentOwnerUuid") public refreshSuppliersWithNewOwner(): void {
        this.hiddenComponent = [];
        if (this.currentOwnerUuid) {
            _.set(this.filters, "ownerUuid", this.currentOwnerUuid);
            _.set(this.filters, "type", null);
            this.getSuppliers();
            if (this.hasFeature("HIDE_PERIOD_COLUMNS")) {
                this.hiddenComponent.push("invoicingPeriod");
                this.hiddenComponent.push("paymentPeriod");
            }

            if (!this.hasFeature(ptfFeatures.request)) {
                this.hiddenComponent.push("request");
            }
        }
    }

    @Watch("filters.marketYear") private changeFiltersMarketYear(newValue: string[], oldValue: string[]) {
      if (this.currentOwnerUuid && _.xor(newValue, oldValue).length > 0) {
        this.getSuppliers();
      }
    }

    @Watch("filters.supplier") private changeFiltersSupplier() {
        this.refreshListSupport();
    }

    @Watch("types") private updatedTypes(): void {
        this.setOptionsRequestType();
    }

    private exportInsertion(): void {
        this.exportDisabled = true;
        const params = { filters: this.filters};
        Http.download(
            "/exportinvoice",
            params,
            (data: Blob) => {
            const url = window.URL.createObjectURL(data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Export insertion.csv");
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.exportDisabled = false;
        },
            "errorDownloadDocument");
    }

    private setOptionsRequestType(): void {
        const options: any = [{key: "", label: _.invoke(this.$options.filters, "trans", "allRequestTypes")}];
        _.forEach(this.types, (type: any) => {
            options.push({key: type.uuid, label: type.label});
        });
        this.optionsRequestType = options;
    }

    private updateHierarchyFilter(selectedOwner: string): void {
        EventBus.$emit("update-filter", _.set({}, "hierarchyOwner", selectedOwner));
    }

    private redirectUrl(name: string): void {
        this.$router.push({ name });
    }

    private showInsertion(insertion: { uuid: string|null }) {
        this.currentInsertionUuid = insertion.uuid;
        this.modalDetailVisible = true;
    }

    public updateFilter(filter: object): void {
        this.filters = Object.assign({}, this.filters, filter);
    }

    private showDocuments(insertion: { uuid: string|null }) {
        this.currentInsertionUuid = insertion.uuid;
        this.modalDocumentVisible = true;
    }

    private getSuppliers(): void {
        this.exportDisabled = true;
        this.loadingSupplier = true;
        this.loadingSupport = true;

        this.$delete(this.filters, "supplier");
        this.optionsSupplier = [{ key: "", label: "allSuppliers" }];

        this.$delete(this.filters, "support");

        const paramsGetSupplier = {
            fields: [
                "advertisingSpace.supplier",
                "advertisingSpace.support",
            ],
            filters: {
                marketYear: _.get(this.filters, "marketYear"),
                listSupplier: true,
                ownerUuid: this.currentOwnerUuid,
            }
        };
        this.allSupport = [];
        InsertionRepository.get(paramsGetSupplier).then((data: object[]) => {
            _.forEach(data, (line) => {
                if (!_.find(this.optionsSupplier, (o) => {
                    return o.key === _.get(line, "advertisingSpace.supplier");
                })) {
                    this.optionsSupplier.push({
                        key: _.get(line, "advertisingSpace.supplier"),
                        label: _.get(line, "advertisingSpace.supplier")
                    });
                }

                this.allSupport.push({
                    key: _.get(line, "advertisingSpace.support"),
                    label: _.get(line, "advertisingSpace.support"),
                    parent: _.get(line, "advertisingSpace.supplier")
                });
            });
            this.loadingSupplier = false;
            this.loadingSupport = false;
            this.refreshListSupport();
            this.exportDisabled = false;
        });
    }

    private refreshListSupport(): void {
        this.$delete(this.filters, "support");
        const selectedSupplier = _.get(this.filters, "supplier");

        this.optionsSupport = [];

        _.forEach(this.allSupport, (supportLine) => {
            if (supportLine.parent === selectedSupplier || !selectedSupplier ) {
                this.optionsSupport.push({
                    key: supportLine.key,
                    label: supportLine.label
                });
            }
        });
        this.optionsSupport = _.uniqBy(
            this.optionsSupport.sort((a, b) => a.label.localeCompare(b.label)),
            (option) => option.label
        );
        this.optionsSupport.unshift({ key: "", label: "allSupports" });
    }
}
